export default "__VITE_ASSET__dfs_PG_W__";